import { ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { SERVICE_DESK_ROUTE_PREFIX } from './common/constants.tsx';

export const servicedeskReportsTypeRoute: InvariantRoute = {
	name: ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE,
	path: `${SERVICE_DESK_ROUTE_PREFIX}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
	query: ['oldIssueView?'],
};
